export type WebsiteAction = "#loyalty-logout";

export const WEBSITE_ACTIONS: WebsiteAction[] = ["#loyalty-logout"];
